import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=7ba2b706&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba2b706"]])

export default __exports__